/**
 * Preset sizes for the Persona.  Should match CoinSize in VSSUI/Coin
 */
export var PersonaSize;
(function (PersonaSize) {
    PersonaSize[PersonaSize["size16"] = 16] = "size16";
    PersonaSize[PersonaSize["size20"] = 20] = "size20";
    PersonaSize[PersonaSize["size24"] = 24] = "size24";
    PersonaSize[PersonaSize["size32"] = 32] = "size32";
    PersonaSize[PersonaSize["size40"] = 40] = "size40";
    PersonaSize[PersonaSize["size72"] = 72] = "size72";
})(PersonaSize || (PersonaSize = {}));
